export default __webpack_public_path__ + "static/media/right-arrow.9e76cc96.svg";